<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="chevron-left-small">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M15.5869 5.97994C15.7821 6.1752 15.7821 6.49179 15.5869 6.68705L10.2738 12.0002L15.5869 17.3133C15.7821 17.5085 15.7821 17.8251 15.5869 18.0204C15.3916 18.2156 15.075 18.2156 14.8798 18.0204L9.2131 12.3537C9.01783 12.1585 9.01783 11.8419 9.2131 11.6466L14.8798 5.97994C15.075 5.78468 15.3916 5.78468 15.5869 5.97994Z" fill="#212328"/>
</g>
</svg>
